'use client';

import React, { useState } from "react";
import { Loader2, Crown } from "lucide-react";
import { Modal } from "./Modal";
import { useTeam, errText } from "../internals";
import { useToast } from "./Toaster";

export const TransferOwnershipDialog = ({ open, member, onClose, onDone }) => {
  const { storage } = useTeam();
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  if (!member) return null;

  const confirm = async () => {
    setBusy(true);
    try {
      await storage.transferOwnership(member.id);
      toast.show(`${member.name} is now the Owner.`, "success");
      onDone && onDone();
      onClose();
    } catch (e) {
      toast.show(errText(e), "error");
      setBusy(false);
    }
  };

  return (
    <Modal open={open} onClose={() => !busy && onClose()} title="Hand over ownership" testId="transfer-ownership-dialog">
      <div className="px-5 py-5">
        <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-amber-100">
          <Crown size={20} className="text-amber-600" />
        </div>
        <p className="text-sm text-zinc-700">
          Pass the Owner role to <span className="font-semibold">{member.name}</span>?
        </p>
        <ul className="mt-3 space-y-1.5 text-sm text-zinc-600">
          <li>• Your own role will change to <span className="font-medium">Admin</span>.</li>
          <li>• {member.name} will be able to manage everyone — including you.</li>
          <li>• They can hand ownership back to you later.</li>
        </ul>
      </div>
      <div className="flex gap-2 border-t border-zinc-200 px-5 py-4">
        <button
          type="button"
          data-testid="transfer-cancel-btn"
          onClick={() => !busy && onClose()}
          disabled={busy}
          className="flex-1 rounded-md border border-zinc-300 px-4 py-2.5 text-sm font-medium text-zinc-700 hover:bg-zinc-50"
        >
          Cancel
        </button>
        <button
          type="button"
          data-testid="transfer-confirm-btn"
          onClick={confirm}
          disabled={busy}
          className="flex flex-1 items-center justify-center gap-2 rounded-md bg-rose-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-rose-700 disabled:opacity-60"
        >
          {busy && <Loader2 size={15} className="animate-spin" />}
          Yes, hand over
        </button>
      </div>
    </Modal>
  );
};
